import React from 'react';
import Button from '../../../components/base/Button';

const HeroSection: React.FC = () => {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/6a8997fb1f8a2c65467ff7fac0a44dac.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-center text-white">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Senin de Yolun <span className="text-teal-400">Netleşsin</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed">
            Çünkü senin yolun, <strong>seninyolun.net</strong>'te anlam bulur.
          </p>
          <p className="text-lg md:text-xl mb-12 max-w-2xl mx-auto text-gray-200">
            ICF akredite koçu <strong>Esin Arifoğlu</strong> ile öğrenci, ebeveyn ve kariyer koçluğu hizmetleri. 
            25+ yıllık deneyim ve bilimsel yaklaşımla hedeflerine ulaş.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button href="/ucretsiz-gorusme" size="lg" className="text-lg px-10 py-4">
              <i className="ri-calendar-line mr-2"></i>
              Ücretsiz Ön Görüşme
            </Button>
            <button
              onClick={() => {
                const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
                if (widget) widget.click();
              }}
              className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap border-2 border-teal-600 text-teal-600 hover:bg-teal-600 hover:text-white px-8 py-4 text-lg text-lg px-10 py-4 border-white text-white hover:bg-white hover:text-gray-900"
            >
              <i className="ri-chat-3-line mr-2"></i>
              Yol Asistanı
            </button>
          </div>
          
          <div className="mt-16 flex justify-center">
            <div className="animate-bounce">
              <i className="ri-arrow-down-line text-3xl text-teal-400"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;